import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TextField, Dropdown, ActionButton } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import paginationStyle from '../style/pagination';

function Pagination(props) {
  const i18n = useContext(I18nContext);
  const {
    classes, pageSize, pageNumber, total, onPageChange, onPageSizeChange, availablePageSizes, hidePageControlForSinglePage, disablePageSizeControl,
  } = props;

  function renderPageSizeControl() {
    const options = availablePageSizes.map(item => ({
      key: item, text: item,
    }));
    const dropdownStyles = {
      dropdown: {
        width: 61,
        marginLeft: 12,
      },
      title: {
        borderColor: '#D9D9D9',
      },
    };
    return (
      <div className={`${classes.pageSizeControl} page-size-control`}>
        {i18n.getString(_TL_('Show rows:'))}
        <Dropdown
          ariaLabel={i18n.getString(_TL_('Show rows:'))}
          title={i18n.getString(_TL_('page size'))}
          options={options}
          styles={dropdownStyles}
          defaultSelectedKey={pageSize}
          onChange={(e, item) => onPageSizeChange(item.key)}
          disabled={disablePageSizeControl}
        />
      </div>
    );
  }

  function renderPageControl() {
    const totalPage = Math.ceil(total / pageSize);
    const textFieldStyles = {
      root: {
        width: 75,
        marginRight: 10,
      },
    };
    return hidePageControlForSinglePage && totalPage <= 1 ?
      null :
      (
        <div className={`${classes.pageControl} page-control`}>
          <ActionButton title={i18n.getString(_TL_('previous page'))} iconProps={{ iconName: 'ChevronLeft' }} disabled={pageNumber === 1} onClick={e => onPageChange(pageNumber - 1, e)} />
          <div className={`${classes.pageNumber} page-number`}>
            <TextField key={pageNumber} title={i18n.getString(_TL_('current page'))} styles={textFieldStyles} disabled defaultValue={pageNumber} />
            {i18n.getString(_TL_('of'))}
            {` ${totalPage}`}
          </div>
          <ActionButton title={i18n.getString(_TL_('next page'))} iconProps={{ iconName: 'ChevronRight' }} disabled={pageNumber === totalPage} onClick={e => onPageChange(pageNumber + 1, e)} />
        </div>
      );
  }

  return (
    <div className={`${classes.Pagination} campaign-details-list-pagination`}>
      {renderPageSizeControl()}
      {renderPageControl()}
    </div>
  );
}

Pagination.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number.isRequired,
  availablePageSizes: PropTypes.oneOfType([
    PropTypes.array,
  ]),
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  hidePageControlForSinglePage: PropTypes.bool,
  disablePageSizeControl: PropTypes.bool,
};


Pagination.defaultProps = {
  pageNumber: 1,
  pageSize: 20,
  onPageChange: () => {},
  onPageSizeChange: () => {},
  availablePageSizes: [20, 50, 100, 200],
  hidePageControlForSinglePage: false,
  disablePageSizeControl: false,
};

const Wrapped = withDefaultStyles(Pagination, paginationStyle);

export { Wrapped as Pagination };
